module.exports = __webpack_public_path__ + "static/media/icon-libra-white.58adaf4c.svg";